import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import i1 from "./assets/images/roogif.gif";
import newbanner from "./assets/images/cryptaroosbanner.png";
import "./assets/style.css"

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #ffffff;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledImg = styled.img`
  width: 200px;
  height: 200px;
  @media (min-width: 767px) {
    width: 350px;
    height: 350px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("");
  const [claimingNft, setClaimingNft] = useState(false);
  const claimNFTs = (_amount) => {
    _amount = document.getElementById("inputBox").value;
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Official CryptaRoo NFT...");
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account, _amount)
      // ********
      // You can change the line above to
      // .whiteListMint(blockchain.account, _amount) if you want only whitelisted
      // users to be able to mint through your website!
      // And after you're done with whitelisted users buying from your website,
      // You can switch it back to .mint(blockchain.account, _amount).
      // ********
      .send({
        gasLimit: 285000 * _amount,
        to: "0x404270B74619401883E8cB6D8f2e08F984acC0c8", // the address of your contract
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((30 * _amount).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong. Check your transaction on Polygonscan to find out what happened!");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "Your CryptaRoo has been successfully minted!"
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen style={{ backgroundColor: "var(--black)", fontSize: 40 }}>
      <s.Container flex={1} ai={"center"} style={{ padding: 24, backgroundImage: "url(https://cryptaroos.github.io/minting/backgroundbanner.png)" }}>
        {/* backgroundColor: "#F78812"  */}
        <s.TextTitle
          style={{
            display: "flex",
            flexDirection: "row", textAlign: "left", fontSize: 12, fontWeight: "bold", paddingRight: 10, margin: 0,
            borderStyle: "solid", borderColor: "black", borderWidth: 0,
            borderRadius: 50, textAlign: "center", justifySelf: "center", justifyContent: "center"
          }}
        >
          <a href="https://opensea.io"><img class="topImage" alt={"BooCrew Logo"}
            src={newbanner}
            style={{ textAlign: "center" }}></img></a>
        </s.TextTitle>
        <s.SpacerMedium />
        <ResponsiveWrapper flex={1} style={{ padding: 24, paddingTop: 0 }}>
          <s.Container flex={1} jc={"center"} ai={"center"} style={{ paddingTop: 0, flexDirection: "column", }}>
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 40,
                fontWeight: "bold",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 5,
                borderRadius: 20,
                marginBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
              }}>
              CryptaRoos 1-550: 30 MATIC + Gas! <br></br>
              CryptaRoos 550-5000: 40 MATIC + Gas!
            </s.TextTitle>
            <StyledImg alt={"BooCrew Hidden"} src={i1} style={{
              paddingTop: 0, borderStyle: "solid", borderColor: "black", borderWidth: 5,
              borderRadius: 10
            }} />
            <s.TextTitle style={{
              textAlign: "center",
              borderStyle: "solid",
              borderColor: "black",
              borderWidth: 5,
              paddingLeft: 100,
              paddingRight: 100,
              borderRadius: 20,
              marginTop: 10,
              marginBottom: 10,
              backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
              fontSize: 30
            }}
              className="questionMarks"
            >
              {blockchain.account == null ? "????" : (data.totalSupply)}/5000
            </s.TextTitle>
            {/* <s.SpacerMedium/> */}
            <s.Container
              flex={1}
              jc={"center"}
              ai={"center"}
              style={{
                backgroundColor: "#FFA537",
                backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                padding: 24,
                paddingTop: 24,
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 10,
                borderRadius: 30,
                fontSize: 40,
                maxWidth: 1500
              }}
            >
              {Number(data.totalSupply) == 5000 ? (
                <>
                  <s.TextTitle style={{ textAlign: "center" }}>
                    The sale has ended.
                  </s.TextTitle>
                  <s.SpacerSmall />
                  <s.TextDescription style={{ textAlign: "center" }}>
                    Dont worry, you're not missing out! You can still get CryptaRoos on{" "}
                    <a
                      // target={"_blank"}
                      href={"https://testnets.opensea.io/collection/rinkeby-doodlenauts"}
                    >
                      Opensea.io
                    </a>
                  </s.TextDescription>
                </>
              ) : (
                <>
                  {/* <s.TextTitle style={{ textAlign: "center", fontSize: 30 }}>
                  1 DOODL costs .01 ETH.
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextDescription style={{ textAlign: "center", fontSize: 30 }}>
                  Excluding gas fees.
                </s.TextDescription>
                <s.SpacerSmall /> */}
                  <s.TextDescription style={{ textAlign: "center", fontSize: 40 }}>
                    {feedback}
                  </s.TextDescription>
                  {/* <s.SpacerMedium /> */}
                  {blockchain.account === "" ||
                    blockchain.smartContract === null ? (
                    <s.Container ai={"center"} jc={"center"}>
                      <s.TextDescription style={{
                        fontSize: 60,
                        textAlign: "center",
                        marginBottom: 0,
                      }}>
                        Connect to the CryptaRoo Minter!
                      </s.TextDescription>
                      <s.SpacerSmall />
                      <StyledButton
                        style={{ fontFamily: "coder" }}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(connect());
                          getData();
                        }}
                      >
                        CONNECT
                      </StyledButton>
                      <s.SpacerLarge />
                      {/* <s.TextDescription style={{textAlign: "center", fontSize: 30, marginBottom: 0, paddingBottom: 0}}>
                      <a href="https://google.com">Boo Crew NFT Smart Contract</a>
                    </s.TextDescription> */}
                      {blockchain.errorMsg !== "" ? (
                        <>
                          <s.SpacerSmall />
                          <s.TextDescription style={{ textAlign: "center", fontSize: 50 }}>
                            {blockchain.errorMsg}
                          </s.TextDescription>
                        </>
                      ) : null}
                    </s.Container>
                  ) : (
                    <s.Container ai={"center"} jc={"center"} fd={"row"} style={{ marginTop: 0, paddingTop: 0 }}>
                      <form>
                        I want <input
                          id="inputBox"
                          placeholder="#"
                          type="number"
                          min="1"
                          max="5"
                          style={{
                            fontSize: 60,
                            textAlign: "center",
                            backgroundColor: "#FFA537",
                            borderWidth: 4,
                            borderColor: "black",
                            borderStyle: "solid",
                            borderRadius: 40,
                            paddingRight: 10,
                            // marginBottom: 20,
                            // paddingLeft: 0,
                            // marginLeft: 0,
                            width: 80,
                            fontFamily: "coder",
                          }}
                        /> CryptaRoo(s)
                      </form>
                      <s.SpacerSmall />
                      <StyledButton
                        style={{ fontFamily: "coder" }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs(1);
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "MINT"}
                      </StyledButton>
                    </s.Container>
                  )}
                </>

              )}
            </s.Container>
            <s.Container
              flex={1}
              jc={"center"}
              ai={"center"}
              style={{
                backgroundColor: "#FFA537",
                backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                padding: 24,
                paddingTop: 0,
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 10,
                borderRadius: 30,
                fontSize: 40,
                marginTop: 20,
                textAlign: "left",
                maxWidth: 1500,
              }}
            >
              <text style={{ marginTop: 20 }}>
                <div style={{
                  textAlign: "center",
                  borderStyle: "solid",
                  borderRadius: 20,
                  borderWidth: 5,
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 10,
                  backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                }}><text className="headerText">CRYPTAROOS ROADMAP </text><br />
                  <text >🇦🇺🦘🥊</text></div>
                <br />

                <div style={{
                  textAlign: "center",
                  borderStyle: "solid",
                  borderRadius: 20,
                  borderWidth: 5,
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 0,
                  paddingTop: 10,
                  backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                }}><text className="titleText" style={{
                }}>Q4 2021</text><s.SpacerXSmall />                </div>
                <text className="subText">
                  •	Prep for launch – Deploy Contracts, set up Minting Page, Marketing Campaign<br />
                  •	Launch – This will be on Sunday the 14th of November at 4pm AEST<br />
                  •	Giveaways and Promotions – Giveaways and Promotions will be running on social media to help push the project out to demographics that will be interested in the project
                  <br />•	Talk to Game Developers about the concept of creating a CryptaRoo game<br />
                  •	Monthly Meetups, AMA’s.<br /><br />
                </text>



                <div style={{
                  textAlign: "center",
                  borderStyle: "solid",
                  borderRadius: 20,
                  borderWidth: 5,
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 10,
                  paddingTop: 10,
                  backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                }}>
                  <text className="titleText" style={{
                  }}>Q1 2022</text></div><s.SpacerXSmall />
                <text className="subText">
                  •	Initial Joey NFT Gen 2 Concept Drawn<br />
                  •	Concept of CryptaRoo marketplace (may not be needed as we have OpenSea)<br />
                  •	Continuance and development of Marketing Strategy<br />
                  •	Development of CryptaRoo game – This will be dependent on the success of the CryptaRoos, if there isn’t interest then it may not be done.
                  <br />•	Monthly Meetups, AMA’s.<br /><br />
                </text>

                <div style={{
                  textAlign: "center",
                  borderStyle: "solid",
                  borderRadius: 20,
                  borderWidth: 5,
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 0,
                  paddingTop: 10,
                  paddingBottom: 10,
                  backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
                }}>
                  <text className="titleText" style={{
                  }}>Q2 2022</text></div><s.SpacerXSmall />

                <text className="subText">
                  •	CryptaRoos Game Beta Launch<br />
                  •	Monthly Meetups, AMA’s.<br />
                  •	Joey NFT Release<br /><br />
                </text>

                <text style={{ fontSize: 20 }}>*More will be added to the roadmap as we continue forward. Of course, not all dates are set in stone, we of course hope to deliver on these dates, but cannot be possible without interest from the community.
                <br />*This is the indicative RoadMap for the project, which is subject to change.
                </text><br />

              </text>
            </s.Container>
          </s.Container>
          {/* <s.SpacerMedium /> */}
        </ResponsiveWrapper>
        <s.SpacerSmall />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.TextDescription style={{
            textAlign: "center", fontSize: 40, borderColor: "black",
            borderStyle: "solid",
            paddingLeft: 10,
            paddingRight: 10,
            borderWidth: 5,
            borderRadius: 20,
            backgroundColor: "white",
            backgroundImage: "linear-gradient(to bottom, #F2CA24, #F0482A)",
          }}>
            <a
              href="https://polygonscan.com/address/0x404270B74619401883E8cB6D8f2e08F984acC0c8"
              style={{
                textDecoration: "none",
                color: "black",

                fontSize: 30,
              }}
            >CryptaRoos NFT Smart Contract</a>
          </s.TextDescription>
          <s.SpacerSmall />
          {/* <s.TextDescription style={{ textAlign: "center", fontSize: 9 }}>
          </s.TextDescription> */}
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
